import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import CardMedia from "@mui/material/CardMedia";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PurchaseTotal from "./PurchaseTotal";
import { PurchaseQuantity } from "./PurchaseQuantity";
import "./cards.css";
import { removeFromCart } from "../../redux/purchaseRequest/purchaseRequestSlice";
import { removeAllFromCart } from "../../redux/purchaseRequest/purchaseRequestSlice";
import { useNavigate } from "react-router-dom";
import { ImagePopup } from "./ImagePopup";
import { Combobox, Transition } from "@headlessui/react";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { setUserStores, storeSet } from "../../redux/store/storeSlice";
import { ServiceApi } from "../../services/index.service";
import { Avatar, Backdrop, CircularProgress } from "@mui/material";


export default function PurchaseRequest(props) {
    const data = useSelector((state) => state);
    const { addedItems } = data?.purchaseRequest;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [openDialog, setOpenDialog] = React.useState(false);
    const [imageData, setImageData] = React.useState({})
    const [query, setQuery] = React.useState("");
    const [store, setStore] = React.useState(null);
    const [storeList, setStoreList] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const serviceapi = new ServiceApi();
    const { storage } = useSelector((state) => state);
    React.useEffect(() => {
        if (data?.profile) {
            getStores();
        }
    }, [data?.profile])

    const continueShopping = () => {
        if(props.directUrl){
            navigate('/buy-merchandise')
        }else{
            navigate('/purchase-merchendise')
        }
    }
    const handleRemoveFromCart = (item) => {
        dispatch(removeFromCart(item.id));
    }
    const handleRemoveAllFromCart = () => {
        dispatch(removeAllFromCart());
    }

    const handleConfirmDialog = () => {
        setOpenDialog(!openDialog);
    }

    const openImagePopup = (item) => {
        setImageData(item)
        setOpenDialog(!openDialog);
    }

    const handleStoreChange = (event) => {
        dispatch(storeSet(event));
        setStore(event);
    };

    const filteredStores =
        query === ""
            ? storeList
            : storeList.filter((store) => {
                let searchString = `${store.intRitasStoreID} - ${store.vchStoreName} - ${store.vchStoreState}`;
                return searchString.toLowerCase().includes(query.toLowerCase());
            });

    const getStores = async () => {
        try {
            setLoading(true);
            const req = {
                role: data?.profile?.role,
                uid: data?.profile?.contact_id,
                user_name: data?.profile?.user_name,
                fsm_name: "all",
                is_merchandise:props?.directUrl ? true :false
            };
            const response = await serviceapi.fetchFCStores(req);
            dispatch(setUserStores(response));
            setStoreList(response);
            setLoading(false);
            if (storage?.store && Object.keys(storage?.store).length) {
                setStore(storage?.store);
            }else {
                setStore(response[0]);
                dispatch(storeSet(response[0]));
            }
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };

    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }

    return (
        <>
            <div className="py-6 mt-16">
                <header>
                    <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
                            Purchase Request
                        </h1>
                        <div className="flex justify-end gap-4 items-baseline">
                            <Combobox as="div" value={store} onChange={handleStoreChange}>
                                <div className="relative mt-1 ml-1">
                                    <div className="absolute inset-y-0 left-0 flex items-center border-r border-gray-200 rounded-r-md px-2 focus:outline-none">
                                        <StorefrontIcon
                                            className="h-5 w-5 text-primary"
                                            size="small"
                                        />
                                    </div>

                                    <Combobox.Input
                                        className="w-full rounded-md border border-gray-300 bg-white py-2 px-10 shadow-sm focus:border-secondary focus:outline-none focus:ring-1 focus:ring-secondary sm:text-sm"
                                        onChange={(event) => setQuery(event.target.value)}
                                        placeholder="Select Store"
                                        // onClick={() => setStore("")}
                                        displayValue={(store) => {
                                            if (store) {
                                                return `${store?.intRitasStoreID} - ${store?.vchStoreName} - ${store?.vchStoreState}`;
                                            }
                                        }}
                                    />

                                    <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                        <ChevronUpDownIcon
                                            className="h-5 w-5 text-gray-400"
                                            aria-hidden="true"
                                        />
                                    </Combobox.Button>
                                    <Transition
                                        // as={Fragment}
                                        leave="transition ease-in duration-100"
                                        leaveFrom="opacity-100"
                                        leaveTo="opacity-0"
                                        afterLeave={() => setQuery("")}
                                    >
                                        {/* {filteredStores.length > 0 && ( */}
                                        <Combobox.Options
                                            style={{ zIndex: 1000 }}
                                            className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                                        >
                                            {filteredStores.map((store) => (
                                                <Combobox.Option
                                                    key={store.intStoreID}
                                                    value={store}
                                                    className={({ active }) =>
                                                        classNames(
                                                            "relative cursor-default select-none py-2 pl-3 pr-9",
                                                            active
                                                                ? "bg-secondary text-white"
                                                                : "text-gray-900"
                                                        )
                                                    }
                                                >
                                                    {({ active, selected }) => (
                                                        <>
                                                            <span
                                                                className={classNames(
                                                                    "block truncate",
                                                                    selected && "font-semibold"
                                                                )}
                                                            >
                                                                {`${store.intRitasStoreID} - ${store.vchStoreName} - ${store.vchStoreState}`}
                                                            </span>

                                                            {selected && (
                                                                <span
                                                                    className={classNames(
                                                                        "absolute inset-y-0 right-0 flex items-center pr-4",
                                                                        active ? "text-white" : "text-secondary"
                                                                    )}
                                                                >
                                                                    <CheckIcon
                                                                        className="h-5 w-5"
                                                                        aria-hidden="true"
                                                                    />
                                                                </span>
                                                            )}
                                                        </>
                                                    )}
                                                </Combobox.Option>
                                            ))}
                                        </Combobox.Options>
                                    </Transition>
                                </div>
                            </Combobox>
                        </div>
                    </div>
                </header>
                <main>
                    <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
                        <div className="px-4 py-8 sm:px-0">
                            {addedItems.length > 0 && (
                                <div className="purchase_request_container">
                                    {/* <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
                                        Purchase Cart
                                    </h1> */}
                                    <div className="purchase_request_list_container">
                                        <div className="purchase_request_list">
                                            <div className="purchase_request_list_header">
                                                <div className="product_name">
                                                    Product
                                                </div>
                                                <div className="product_price">
                                                    Price
                                                </div>
                                                <div className="product_quantity">
                                                    Quantity
                                                </div>
                                                <div className="product_subtotal">
                                                    SubTotal
                                                </div>
                                            </div>
                                            {addedItems.length > 0 && addedItems.map(item => {
                                                let attributes=null
                                                if(item?.attributes !== "null"){
                                                    attributes = JSON.parse(item?.attributes);
                                                }
                                                const color=attributes?.color
                                                const size=attributes?.size
                                                let productImage=null
                                                if(item?.images !=="NA"){
                                                    productImage = JSON.parse(item?.images);
                                                }

                                                return (
                                                    <div key={item?.id} className="purchase_request_body_container">
                                                        <div className="purchase_request_details">
                                                            <Card style={{ display: "flex", width: "100%", justifyContent: "space-between" }} >
                                                                <div className="product_container">
                                                                    <div className="product_image cursor-pointer">
                                                                        <Avatar sx={{ margin: 'auto', bgcolor: '#fff' }} variant="rounded" >
                                                                            <img src={productImage?.[0]?.thumbnail} 
                                                                                onClick={() => openImagePopup({
                                                                                    'img_thumbs' : productImage?.[0]?.thumbnail,
                                                                                    'name'       : item?.name })
                                                                                } 
                                                                                alt="productImages"
                                                                                style={{ height: '100%' }} 
                                                                            />
                                                                        </Avatar>
                                                                    </div>
                                                                    <div className="product_information">
                                                                        <CardContent>
                                                                            <Typography className="purchase_requst_card_name" title={item?.name} >
                                                                                {/* {item.name} */}
                                                                                {item?.name.substring(0, 45)}...
                                                                            </Typography>
                                                                            <Typography>
                                                                                <div className="purchase_requst_card_sub_name">
                                                                                    {<span>Color: {color}</span>}, &nbsp;
                                                                                    {<span>Type: {size}</span>}
                                                                                </div>
                                                                                {/* {meterial && <span>Meterial: {meterial}</span>}<br />
                                                            {seller && <span>Seller: {seller}</span>} */}
                                                                            </Typography>
                                                                        </CardContent>
                                                                        <CardActions>
                                                                            {/* {console.log(item)} */}
                                                                            <Button className="Purchase_request_remove_btn mb-2"
                                                                                sx={{ textTransform: 'capitalize !important' }}
                                                                                onClick={() => handleRemoveFromCart(item)}>
                                                                                remove
                                                                            </Button>
                                                                        </CardActions>
                                                                    </div>
                                                                </div>
                                                                <div className="product_price">
                                                                    ${item.price}
                                                                </div>
                                                                <div className="product_quantity">
                                                                    <PurchaseQuantity currentItem={item} />
                                                                </div>
                                                                <div className="product_subtotal">
                                                                    ${(item.price * item.quantity).toFixed(2)}
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            }
                                            <div className="remove_all">
                                                <CardActions className="cards_actions">
                                                    <Button
                                                        className="purchasecart_remove_btn"
                                                        sx={{ textTransform: 'capitalize !important' }}
                                                        onClick={() => handleRemoveAllFromCart()}
                                                    >
                                                        Remove all
                                                    </Button>
                                                </CardActions>
                                                <CardActions className="cards_actions">
                                                    <Button
                                                        className="purchasecart_continueshipping_btn"
                                                        sx={{ textTransform: 'capitalize !important' }}
                                                        onClick={continueShopping}
                                                    >
                                                        Continue Shopping
                                                    </Button>
                                                </CardActions>
                                            </div>
                                        </div>
                                        <div className="purchase_submit_request_container">
                                            <PurchaseTotal directUrl={props?.directUrl} />
                                        </div>
                                    </div>
                                </div>
                            )
                            }
                            {
                                addedItems?.length <= 0 && (

                                    <div className="flex justify-between items-baseline" style={{
                                        border: "1px solid #ccc",
                                        padding: "10px",
                                        margin: "10px",
                                        backgroundColor: "#FFF",
                                        color: "#000",
                                        borderRadius: '10px'
                                    }}>
                                        <div

                                        >
                                            Your card is empty, please add items to the cart!
                                        </div>
                                        <Button
                                            className="purchasecart_continueshipping_btn"
                                            sx={{ textTransform: 'capitalize !important' }}
                                            onClick={continueShopping}
                                        >
                                            Continue Shopping
                                        </Button>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </main>
            </div>
            {openDialog && <ImagePopup openDialog={openDialog} handleConfirmDialog={handleConfirmDialog} imageData={imageData} />}
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}
